/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import { exists } from "utils/empty-exists";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
// FIXME: ContentZoneEdit must load before AddComponentBar, otherwise we get bad references
import { ContentZoneEdit } from "cms/components/layout/content-zone-edit";
import { AddComponentBar } from "cms/components/layout/add-component/add-component-bar";
import { useComposerMode } from "cms/components/hooks/use-composer-mode";
import { ComponentErrorFallback } from "./component-error";
import { Logger } from "cms/utils/log/logger";
import { ErrorBoundary } from "react-error-boundary";

/**
 This component is the parent to the content-zone-edit
 - which loops on components and adds the component editors
 - A content api request is made here to load the content with components data.
 - manage state for the components within a model here pushing updates from each component editor
 */
const ContentZone = () => {

    const { editMode, contentOnly } = useComposerMode();

    const { field } = useCurrentDynamicField();
    const fieldName = field?.name;
    const settings = field?.settings;

    return (
        <Fragment>
            <ErrorBoundary
                FallbackComponent={ComponentErrorFallback}
                onReset={() => {
                    // reset the state of your app so the error doesn't happen again
                    Logger.warn("Component Error occurred and user attempted a reset.");
                    location.reload();
                }}
            >
                {exists(field) && (
                    <Fragment>

                        <ContentZoneEdit
                            fieldName={fieldName}
                            settings={settings}
                        />

                        {editMode && !contentOnly && (
                            <AddComponentBar
                                field={field}
                            />
                        )}
                    </Fragment>
                )}
            </ErrorBoundary>
        </Fragment>
    );
};

export { ContentZone };
